import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import packages from './Packages'
import auth from './Auth'
import user from './User'
import category from './Category'
import cookie from './CookieDisclaimer'
import popup from './Popup'
import pushMenu from './PushMenu'
import util from './Util'

const appReducer = combineReducers({
    util,
    packages,
    user,
    auth,
    category,
    cookie,
    popup,
    pushMenu,
    routing: routerReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT_FULFILLED') {
        state = undefined
    }

    return appReducer(state, action)
};

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js